export function explicitlyEnabled(value: unknown): boolean {
  return value === "true";
}

export const showDemoAccounts = explicitlyEnabled(
  import.meta.env.VITE_SHOW_DEMO_ACCOUNTS,
);

export const allowDemoReset = explicitlyEnabled(
  import.meta.env.VITE_ALLOW_DEMO_RESET,
);
